import { ErrorPage } from '@zillow/zrs-zillow-offers';

import HeadWrapper from '../../components/HeadWrapper';
import { StyledPage } from '../../containers/NotFoundPage/styles';

import ErrorMessageConstants from '../../constants/ErrorMessageConstants';

type TechnicalDifficultiesPageProps = {
  errorCode?: number;
  errorMessage?: string;
  title?: string;
};

const TechnicalDifficultiesPage = ({
  errorCode = 500,
  errorMessage = ErrorMessageConstants.TECHNICAL_DIFFICULTIES,
  title = 'Technical difficulties',
}: TechnicalDifficultiesPageProps) => (
  <StyledPage>
    <>
      <HeadWrapper title={title} />

      <ErrorPage
        errorCode={errorCode}
        errorMessage={errorMessage}
        homePageText="Return to Zillow"
        homePageUrl="https://www.zillow.com"
      />
    </>
  </StyledPage>
);

export default TechnicalDifficultiesPage;
